import styled from 'styled-components';

type TableHeaderProps = {
  backgroundColor?: string;
  color?: string;
};

export const TableHeader = styled.thead<TableHeaderProps>`
  background-color: ${(props) => props.backgroundColor ?? props.theme.palette.grayTwo};
  color: ${(props) => props.color ?? props.theme.palette.gray};
`;
